export default {
  setState: 'Setze Anlagen status',
  stop: 'Stoppe: {eventType}',
  start: 'Starte: {eventType}',
};
